export const PERFIS = {
  lucas: {
    id: "lucas",
    nome: "Lucas",
    email: "lucas@aprovado.com",
    avatar: "👨‍💼",
    cor: "#2563eb",
    corClara: "#dbeafe",
    materias: [
      "direito_constitucional",
      "direito_administrativo",
      "direito_penal",
      "direito_processual_penal",
      "legislacao_extravagante",
      "legislacao_transito",
      "direitos_humanos",
      "geopolitica",
      "informatica",
      "atualidades",
      "lingua_portuguesa",
      "lingua_inglesa",
      "etica"
    ]
  },
  alyce: {
    id: "alyce",
    nome: "Alyce",
    email: "alyce@aprovado.com",
    avatar: "👩‍💼",
    cor: "#7c3aed",
    corClara: "#ede9fe",
    materias: [
      "direito_constitucional",
      "direito_administrativo",
      "informatica",
      "lingua_portuguesa",
      "etica",
      "arquivologia",
      "administracao_publica",
      "legislacao_prf"
    ]
  }
};

export const MATERIAS = {
  direito_constitucional: {
    id: "direito_constitucional",
    nome: "Direito Constitucional",
    icone: "⚖️",
    cor: "#1d4ed8",
    corFundo: "#dbeafe",
    descricao: "CF/88, princípios, direitos fundamentais, organização do Estado",
    grupo: "juridicas"
  },
  direito_administrativo: {
    id: "direito_administrativo",
    nome: "Direito Administrativo",
    icone: "🏛️",
    cor: "#065f46",
    corFundo: "#d1fae5",
    descricao: "Atos administrativos, poderes, licitação, servidores",
    grupo: "juridicas"
  },
  direito_penal: {
    id: "direito_penal",
    nome: "Direito Penal",
    icone: "🔐",
    cor: "#991b1b",
    corFundo: "#fee2e2",
    descricao: "Teoria do crime, penas, crimes em espécie",
    grupo: "juridicas"
  },
  direito_processual_penal: {
    id: "direito_processual_penal",
    nome: "Processo Penal",
    icone: "📋",
    cor: "#5b21b6",
    corFundo: "#ede9fe",
    descricao: "Inquérito, processo, provas, recursos",
    grupo: "juridicas"
  },
  legislacao_extravagante: {
    id: "legislacao_extravagante",
    nome: "Legislação Extravagante",
    icone: "📜",
    cor: "#92400e",
    corFundo: "#fef3c7",
    descricao: "Lei de drogas, ECA, Lei de Armas, Maria da Penha",
    grupo: "juridicas"
  },
  legislacao_transito: {
    id: "legislacao_transito",
    nome: "Legislação de Trânsito",
    icone: "🚔",
    cor: "#0e7490",
    corFundo: "#cffafe",
    descricao: "CTB, infrações, habilitação, fiscalização PRF",
    grupo: "prf"
  },
  legislacao_prf: {
    id: "legislacao_prf",
    nome: "Legislação Relativa à PRF",
    icone: "🚗",
    cor: "#0369a1",
    corFundo: "#e0f2fe",
    descricao: "Legislação específica da Polícia Rodoviária Federal",
    grupo: "prf"
  },
  direitos_humanos: {
    id: "direitos_humanos",
    nome: "Direitos Humanos",
    icone: "🤝",
    cor: "#b45309",
    corFundo: "#fef3c7",
    descricao: "Tratados internacionais, proteção, mecanismos",
    grupo: "prf"
  },
  geopolitica: {
    id: "geopolitica",
    nome: "Geopolítica",
    icone: "🌎",
    cor: "#166534",
    corFundo: "#dcfce7",
    descricao: "Relações internacionais, blocos, conflitos globais",
    grupo: "gerais"
  },
  informatica: {
    id: "informatica",
    nome: "Informática",
    icone: "💻",
    cor: "#1e40af",
    corFundo: "#dbeafe",
    descricao: "Hardware, software, redes, segurança, escritório",
    grupo: "gerais"
  },
  atualidades: {
    id: "atualidades",
    nome: "Atualidades",
    icone: "📰",
    cor: "#6b21a8",
    corFundo: "#f3e8ff",
    descricao: "Fatos recentes, Brasil e mundo, política, economia",
    grupo: "gerais"
  },
  lingua_portuguesa: {
    id: "lingua_portuguesa",
    nome: "Língua Portuguesa",
    icone: "📝",
    cor: "#9a3412",
    corFundo: "#ffedd5",
    descricao: "Gramática, interpretação, ortografia, redação",
    grupo: "gerais"
  },
  lingua_inglesa: {
    id: "lingua_inglesa",
    nome: "Língua Inglesa",
    icone: "🇺🇸",
    cor: "#1e3a5f",
    corFundo: "#dbeafe",
    descricao: "Gramática, vocabulário, interpretação de textos",
    grupo: "gerais"
  },
  etica: {
    id: "etica",
    nome: "Ética",
    icone: "🧭",
    cor: "#134e4a",
    corFundo: "#ccfbf1",
    descricao: "Ética no serviço público, conduta, valores",
    grupo: "gerais"
  },
  arquivologia: {
    id: "arquivologia",
    nome: "Arquivologia",
    icone: "🗂️",
    cor: "#713f12",
    corFundo: "#fef9c3",
    descricao: "Gestão documental, arquivos, preservação",
    grupo: "gerais"
  },
  administracao_publica: {
    id: "administracao_publica",
    nome: "Administração Pública",
    icone: "🏢",
    cor: "#1e3a5f",
    corFundo: "#e0f2fe",
    descricao: "Gestão pública, organização, estrutura administrativa",
    grupo: "gerais"
  },
  legislacao_penal_especial: {
    id: "legislacao_penal_especial",
    nome: "Legislação Penal Especial",
    icone: "⚔️",
    cor: "#7c3aed",
    corFundo: "#ede9fe",
    descricao: "Tortura, abuso de autoridade, organização criminosa, lavagem",
    grupo: "juridicas"
  },

  // ─── NOVAS MATÉRIAS ───

  criminologia: {
    id: "criminologia",
    nome: "Criminologia",
    icone: "🔍",
    cor: "#dc2626",
    corFundo: "#fee2e2",
    descricao: "Teoria do crime, vitimologia, criminologia clínica e crítica",
    grupo: "pcba"
  },
  legislacao_previdenciaria: {
    id: "legislacao_previdenciaria",
    nome: "Legislação Previdenciária",
    icone: "🛡️",
    cor: "#0369a1",
    corFundo: "#e0f2fe",
    descricao: "RGPS, benefícios, custeio, Lei 8.213/91 e Lei 8.212/91",
    grupo: "inss"
  },
  direito_tributario: {
    id: "direito_tributario",
    nome: "Direito Tributário",
    icone: "💰",
    cor: "#ca8a04",
    corFundo: "#fef9c3",
    descricao: "CTN, tributos, obrigação tributária, lançamento, crédito tributário",
    grupo: "inss"
  },
  raciocinio_logico: {
    id: "raciocinio_logico",
    nome: "Raciocínio Lógico",
    icone: "🧮",
    cor: "#0891b2",
    corFundo: "#cffafe",
    descricao: "Lógica proposicional, sequências, problemas matemáticos",
    grupo: "gerais"
  },
  conhecimentos_bancarios: {
    id: "conhecimentos_bancarios",
    nome: "Conhecimentos Bancários",
    icone: "🏦",
    cor: "#059669",
    corFundo: "#d1fae5",
    descricao: "Sistema financeiro nacional, produtos bancários, mercado de capitais",
    grupo: "bancario"
  },
  legislacao_pcba: {
    id: "legislacao_pcba",
    nome: "Legislação PCBA",
    icone: "👮",
    cor: "#1e40af",
    corFundo: "#dbeafe",
    descricao: "Legislação específica da Polícia Civil da Bahia",
    grupo: "pcba"
  },
  igualdade_racial_genero: {
    id: "igualdade_racial_genero",
    nome: "Promoção da Igualdade Racial e de Gênero",
    icone: "⚖️",
    cor: "#be185d",
    corFundo: "#fce7f3",
    descricao: "Igualdade racial e de gênero conforme o edital PCBA 2026",
    grupo: "pcba"
  },
  medicina_legal: {
    id: "medicina_legal",
    nome: "Medicina Legal",
    icone: "🩺",
    cor: "#0f766e",
    corFundo: "#ccfbf1",
    descricao: "Perícias, traumatologia, tanatologia e vestígios",
    grupo: "pcba"
  },
  legislacao_geral: {
    id: "legislacao_geral",
    nome: "Legislação Geral",
    icone: "📜",
    cor: "#4338ca",
    corFundo: "#e0e7ff",
    descricao: "Legislação estadual da Bahia e Estatuto da Advocacia",
    grupo: "pcba"
  },
  contabilidade: {
    id: "contabilidade",
    nome: "Noções de Contabilidade",
    icone: "🧮",
    cor: "#047857",
    corFundo: "#d1fae5",
    descricao: "Fundamentos, escrituração, demonstrações e finanças",
    grupo: "pcba"
  },
  estatistica: {
    id: "estatistica",
    nome: "Estatística",
    icone: "📊",
    cor: "#7c3aed",
    corFundo: "#ede9fe",
    descricao: "Estatística descritiva, probabilidade e amostragem",
    grupo: "pcba"
  },
};

export const FRASES_MOTIVACIONAIS = [
  "A aprovação não é um destino, é uma consequência da sua disciplina diária. 🎯",
  "Cada flashcard estudado hoje é um passo a menos para a aprovação. 💪",
  "Concurseiros aprovados não são os mais inteligentes — são os mais consistentes. 🏆",
  "Você não precisa ser perfeito todos os dias. Precisa aparecer todos os dias. 📅",
  "A revisão de hoje é a aprovação de amanhã. 🔄",
  "Foque no processo. Os resultados são consequência. ⚡",
  "Cada erro é uma oportunidade disfarçada de aprendizado. 📖",
  "O sacrifício de hoje é o salário de amanhã. 💰",
  "Estude como se dependesse só de você. Acredite como se Deus fosse fazer a prova por você. 🙏",
  "A distância entre sonho e realidade chama-se disciplina. 🎓",
  "Não desista. O funcionário público que você vai substituir também teve que estudar. 😄",
  "Seu futuro cargo já foi aprovado na sua mente. Agora é hora de provar na prova. 🚔",
  "Um dia ruim de estudos ainda é melhor que um dia sem estudar. 📚",
  "A banca não aprova quem sabe tudo. Aprova quem erra menos. 🎯",
  "Consistência supera intensidade. Apareça todos os dias, mesmo que por pouco tempo. ⏰"
];
